import { DAY_MS } from "./dates";

/**
 * Hệ thống Leitner 5 hộp. Trả lời đúng → lên hộp; sai → về hộp 1.
 * Khoảng ôn (ngày) theo hộp: 1→0 (ôn ngay), 2→1, 3→3, 4→7, 5→16.
 */
export const BOX_INTERVAL_DAYS = [0, 0, 1, 3, 7, 16] as const;
export const MAX_BOX = 5;

export interface SrsState {
  box: number;
  due: number;
}

export function nextSrs(prev: SrsState | undefined, correct: boolean, now: number): SrsState {
  const box = correct ? Math.min(MAX_BOX, (prev?.box ?? 0) + 1) : 1;
  const days = BOX_INTERVAL_DAYS[box] ?? 0;
  return { box, due: now + days * DAY_MS };
}

export function isDue(s: SrsState | undefined, now: number): boolean {
  return s !== undefined && s.due <= now;
}

/** Thành thạo = đang ở hộp ≥ 3 (đã đúng liên tiếp nhiều lần qua các khoảng ôn). */
export function isMastered(s: SrsState | undefined): boolean {
  return (s?.box ?? 0) >= 3;
}
